import { render } from "./RevenueSummary.vue?vue&type=template&id=737ef010&scoped=true"
import script from "./RevenueSummary.vue?vue&type=script&lang=js"
export * from "./RevenueSummary.vue?vue&type=script&lang=js"

import "./RevenueSummary.vue?vue&type=style&index=0&id=737ef010&scoped=true&lang=css"

import exportComponent from "C:\\Development\\konnektor\\scores\\kon-platform-wallboards-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737ef010"]])

export default __exports__